<template>
    <v-img ref="img" :src="imageUrl" :width="width" :aspect-ratio="ar" v-bind="$attrs" >
        <slot />
    </v-img>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'v-auto-img',

    props: ['src', 'width', 'ar'],

    data: () => ({
        imageUrl: null
    }),

    watch: {
        src: {
            immediate: true,
            handler() {
                this.updateImageUrl();
            }
        }
    },

    methods: {
        updateImageUrl() {
            if (this.$refs.img) {
                this.setImageUrl();
            } else {
                Vue.nextTick(this.setImageUrl);
            }
        },
        setImageUrl() {
            let width = parseInt(this.width);
            if (!width) {
                width = (this.$refs.img && this.$refs.img.$el.clientWidth) || 100;
            }
            
            for (let w of this.$api.thumbnailSizes.concat([null])) {
                if (width <= w || !w) {
                    this.imageUrl = this.$api.getImageUrl(this.src, w);
                    break;
                }
            }
        }
    }
}
</script>
